import { UserFilterType, UserType } from 'store/models/user';

export const ADMINS = [UserType.Admin, UserType.SuperAdmin];

export const USERS_FILTER_TYPES_INT = [
    UserFilterType.EmployerId,
    UserFilterType.HHId,
    UserFilterType.AccountId,
    UserFilterType.UserId,
    UserFilterType.CampaignId,
    UserFilterType.BannerId,
];

export const USERS_FILTER_TYPES = [
    UserFilterType.EmployerId,
    UserFilterType.HHId,
    UserFilterType.AccountId,
    UserFilterType.UserId,
    UserFilterType.Any,
    UserFilterType.Name,
    UserFilterType.Email,
    UserFilterType.CampaignId,
    UserFilterType.BannerId,
];

export const CURRENT_ACCOUNT_ID_STORAGE = 'CURRENT_ACCOUNT_ID';
